import reduceQueryToObject from './reduceQueryToObject'

/**
 * @param {Array.<string>} packagesStructure
 * @param {string} query
 * @param {Array.<string>?} bundles
 * @constructor
 */
function PackagesUtil(packagesStructure, query, bundles = []) {
  const queryParamsObject = reduceQueryToObject(query.replace(/^\?/, ''))

  /**
   * changes the config to load packages correctly, accounting the query
   * @param {Object} config
   * @returns {Object}
   */
  this.buildConfig = function (config) {
    let debug = (decodeURIComponent(queryParamsObject.debug) || '').split(',').filter(Boolean)

    if (debug.indexOf('all') !== -1) {
      const debuggableExternals = Object.keys(config.paths).filter(path => config.paths[path].source)
      debug = packagesStructure.concat(debuggableExternals)
    }

    function isInDebug(i) {
      return debug.indexOf(i) !== -1
    }

    //config.paths:
    Object.keys(config.paths)
      .filter(k => typeof config.paths[k] === 'object' && !Array.isArray(config.paths[k]))
      .forEach(k => {config.paths[k] = config.paths[k][isInDebug(k) ? 'source' : 'min']})

    //config.bundles:
    config.bundles = config.bundles || {}

    packagesStructure
      .filter(p => !isInDebug(p))
      .filter(p => bundles.indexOf(p) === -1)
      .forEach(pkg => {
        config.bundles[pkg] = pkg
        config.paths[pkg] = `packages-bin/${pkg}/${pkg}.min`
      })

    if (bundles && bundles.length > 0) {
      const bundleName = 'first-load'
      config.bundles[bundleName] = bundles
      config.paths[bundleName] = `packages-bin/${bundleName}/${bundleName}.min`
    }

    //config.packages:
    config.packages = config.packages || []
    const projectPackages = packagesStructure.filter(isInDebug).map(name =>
      ({
        name,
        location: `packages/${name}/src/main`,
        main: name
      })
    )
    config.packages = config.packages.concat(projectPackages)

    return config
  }
}

export default PackagesUtil



// WEBPACK FOOTER //
// ./~/santa-main-r/src/lib/common/PackagesUtil.js